import React from "react";
import ContactFormChronicV2 from "./contactFormChronicV2";

const ContactFormImageV2 = ({ content }) => {
  const { title, subtitle, image, contactFormV2 } = content;
  return (
    <div id="ContactFormImageV2">
      <div className="wrap">
        <div className="contactPhoto">
          <img src={image.url} alt="contactFormImageV2" />
        </div>
        <div className="content">
          <div className="title">{title}</div>
          <div className="subtitle">{subtitle}</div>
          <ContactFormChronicV2 content={contactFormV2} />
        </div>
      </div>
    </div>
  );
};

export default ContactFormImageV2;
